/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Raffle,
  RaffleEntries,
  RaffleEntriesParams,
  RaffleInput,
  Raffles,
  RafflesParams,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create Raffle
 */
export const createRaffle = (
    raffleInput: MaybeRefOrGetter<RaffleInput>,
 signal?: AbortSignal
) => {
      raffleInput = toValue(raffleInput);

      return axiosClient<Raffle>(
      {url: `/raffles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: raffleInput, signal
    },
      );
    }




export const getCreateRaffleMutationKey = () => ['createRaffle'] as const;

export const getCreateRaffleMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRaffle>>, TError,CreateRaffleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createRaffle>>, TError,CreateRaffleMutationVariables, TContext> => {

const mutationKey = getCreateRaffleMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRaffle>>, CreateRaffleMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createRaffle(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRaffleMutationResult = NonNullable<Awaited<ReturnType<typeof createRaffle>>>
    export type CreateRaffleMutationBody = RaffleInput
    export type CreateRaffleMutationError = ErrorType<ValidationError | StandardError>
    export type CreateRaffleMutationVariables = {data: RaffleInput}

    /**
 * @summary Create Raffle
 */
export const useCreateRaffle = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRaffle>>, TError,CreateRaffleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createRaffle>>,
        TError,
        CreateRaffleMutationVariables,
        TContext
      > => {
      return useMutation(getCreateRaffleMutationOptions(options), queryClient);
    }
    /**
 * @summary Raffles list
 */
export const raffles = (
    params?: MaybeRefOrGetter<RafflesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Raffles>(
      {url: `/raffles`, method: 'GET',
        params, signal
    },
      );
    }




export const getRafflesQueryKey = (params?: MaybeRefOrGetter<RafflesParams>,) => {
    return [
    'raffles', ...(params ? [params] : [])
    ] as const;
    }


export const getRafflesQueryOptions = <TData = Awaited<ReturnType<typeof raffles>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<RafflesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof raffles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getRafflesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof raffles>>> = ({ signal }) => raffles(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof raffles>>, TError, TData>
}

export type RafflesQueryResult = NonNullable<Awaited<ReturnType<typeof raffles>>>
export type RafflesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Raffles list
 */

export function useRaffles<TData = Awaited<ReturnType<typeof raffles>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<RafflesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof raffles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRafflesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Raffle Detail
 */
export const raffle = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Raffle>(
      {url: `/raffles/${id}`, method: 'GET', signal
    },
      );
    }




export const getRaffleQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'raffles',id
    ] as const;
    }


export const getRaffleQueryOptions = <TData = Awaited<ReturnType<typeof raffle>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof raffle>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getRaffleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof raffle>>> = ({ signal }) => raffle(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof raffle>>, TError, TData>
}

export type RaffleQueryResult = NonNullable<Awaited<ReturnType<typeof raffle>>>
export type RaffleQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Raffle Detail
 */

export function useRaffle<TData = Awaited<ReturnType<typeof raffle>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof raffle>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRaffleQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Raffle
 */
export const updateRaffle = (
    id: MaybeRefOrGetter<string>,
    raffleInput: MaybeRefOrGetter<RaffleInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
raffleInput = toValue(raffleInput);

      return axiosClient<Raffle>(
      {url: `/raffles/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: raffleInput, signal
    },
      );
    }




export const getUpdateRaffleMutationKey = () => ['updateRaffle'] as const;

export const getUpdateRaffleMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRaffle>>, TError,UpdateRaffleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateRaffle>>, TError,UpdateRaffleMutationVariables, TContext> => {

const mutationKey = getUpdateRaffleMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRaffle>>, UpdateRaffleMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateRaffle(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRaffleMutationResult = NonNullable<Awaited<ReturnType<typeof updateRaffle>>>
    export type UpdateRaffleMutationBody = RaffleInput
    export type UpdateRaffleMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateRaffleMutationVariables = {id: string;data: RaffleInput}

    /**
 * @summary Update Raffle
 */
export const useUpdateRaffle = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRaffle>>, TError,UpdateRaffleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateRaffle>>,
        TError,
        UpdateRaffleMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateRaffleMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Raffle
 */
export const destroyRaffle = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Raffle>(
      {url: `/raffles/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyRaffleMutationKey = () => ['destroyRaffle'] as const;

export const getDestroyRaffleMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyRaffle>>, TError,DestroyRaffleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyRaffle>>, TError,DestroyRaffleMutationVariables, TContext> => {

const mutationKey = getDestroyRaffleMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyRaffle>>, DestroyRaffleMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyRaffle(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyRaffleMutationResult = NonNullable<Awaited<ReturnType<typeof destroyRaffle>>>

    export type DestroyRaffleMutationError = ErrorType<ValidationError | StandardError>
    export type DestroyRaffleMutationVariables = {id: string}

    /**
 * @summary Destroy Raffle
 */
export const useDestroyRaffle = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyRaffle>>, TError,DestroyRaffleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyRaffle>>,
        TError,
        DestroyRaffleMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyRaffleMutationOptions(options), queryClient);
    }
    /**
 * @summary Draw Raffle
 */
export const drawRaffle = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Raffle>(
      {url: `/raffles/${id}/draw`, method: 'POST', signal
    },
      );
    }




export const getDrawRaffleMutationKey = () => ['drawRaffle'] as const;

export const getDrawRaffleMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drawRaffle>>, TError,DrawRaffleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof drawRaffle>>, TError,DrawRaffleMutationVariables, TContext> => {

const mutationKey = getDrawRaffleMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof drawRaffle>>, DrawRaffleMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  drawRaffle(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DrawRaffleMutationResult = NonNullable<Awaited<ReturnType<typeof drawRaffle>>>

    export type DrawRaffleMutationError = ErrorType<ValidationError | StandardError>
    export type DrawRaffleMutationVariables = {id: string}

    /**
 * @summary Draw Raffle
 */
export const useDrawRaffle = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof drawRaffle>>, TError,DrawRaffleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof drawRaffle>>,
        TError,
        DrawRaffleMutationVariables,
        TContext
      > => {
      return useMutation(getDrawRaffleMutationOptions(options), queryClient);
    }
    /**
 * @summary Raffle entries
 */
export const raffleEntries = (
    raffleId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<RaffleEntriesParams>,
 signal?: AbortSignal
) => {
      raffleId = toValue(raffleId);
params = toValue(params);

      return axiosClient<RaffleEntries>(
      {url: `/raffles/${raffleId}/entries`, method: 'GET',
        params, signal
    },
      );
    }




export const getRaffleEntriesQueryKey = (raffleId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<RaffleEntriesParams>,) => {
    return [
    'raffles',raffleId,'entries', ...(params ? [params] : [])
    ] as const;
    }


export const getRaffleEntriesQueryOptions = <TData = Awaited<ReturnType<typeof raffleEntries>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(raffleId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<RaffleEntriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof raffleEntries>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getRaffleEntriesQueryKey(raffleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof raffleEntries>>> = ({ signal }) => raffleEntries(raffleId,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(raffleId) !== null && toValue(raffleId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof raffleEntries>>, TError, TData>
}

export type RaffleEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof raffleEntries>>>
export type RaffleEntriesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Raffle entries
 */

export function useRaffleEntries<TData = Awaited<ReturnType<typeof raffleEntries>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 raffleId: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<RaffleEntriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof raffleEntries>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRaffleEntriesQueryOptions(raffleId,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






